import React, { useCallback } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface IFSCCodeInputProps {
  value?: { beneficiary_ifsc?: string };
  onChange?: (value: { beneficiary_ifsc: string }) => void;
  disabled?: boolean;
}

/**
 * Atomic component for IFSC Code input
 * Component ID: LOS_IFSCCodeInput_430
 * Getter API: LOS_GetIFSCCode_425
 * Setter API: LOS_SetIFSCCode_426
 */
const IFSCCodeInput: React.FC<IFSCCodeInputProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const currentValue = value?.beneficiary_ifsc || '';

  const handleChange = useCallback((val: string) => {
    // Auto-uppercase and remove spaces
    const sanitized = val.toUpperCase().replace(/\s/g, '');
    if (onChange) {
      onChange({ beneficiary_ifsc: sanitized });
    }
  }, [onChange]);

  return (
    <div className="space-y-1.5">
      <Label htmlFor="ifsc_code">
        IFSC Code <span className="text-red-500">*</span>
      </Label>
      <Input
        id="ifsc_code"
        type="text"
        placeholder="e.g., SBIN0001234"
        value={currentValue}
        onChange={(e) => handleChange(e.target.value)}
        disabled={disabled}
        maxLength={11}
      />
      <p className="text-xs text-gray-500">
        Format: 4 letters + 0 + 6 alphanumeric characters
      </p>
    </div>
  );
};

export default IFSCCodeInput;
